import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { X } from "lucide-react";
import { getLeads, saveLeads, CLOSER_ACCOUNTS } from "./demoConfig";

export default function NewLeadModal({ open, onClose, auth, onSave }) {
  const [form, setForm] = useState({
    clientName: "",
    clientLastName: "",
    targetRole: "",
    targetMarket: "",
    whatsappNumber: "",
    scheduledAt: "",
    closerUsername: auth.username,
    notes: "",
  });

  if (!open) return null;

  const update = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  const handleSave = () => {
    if (!form.clientName || !form.targetRole || !form.targetMarket) return;
    const closer = CLOSER_ACCOUNTS.find((a) => a.username === form.closerUsername);
    const newLead = {
      id: crypto.randomUUID(),
      clientName: form.clientName,
      clientLastName: form.clientLastName,
      targetRole: form.targetRole,
      targetMarket: form.targetMarket,
      whatsappNumber: form.whatsappNumber,
      scheduledAt: form.scheduledAt ? new Date(form.scheduledAt).toISOString() : new Date().toISOString(),
      closerUsername: form.closerUsername,
      closerName: closer?.name || auth.name,
      notes: form.notes,
      status: "upcoming",
      demoDoneAt: null,
      weeklyApps: null,
      targetSalary: null,
      monthsSearching: null,
      recommendedPlan: null,
      followUpMessage: null,
      paymentSentAt: null,
      convertedAt: null,
      convertedAmount: null,
      createdAt: new Date().toISOString(),
    };
    const leads = getLeads();
    leads.push(newLead);
    saveLeads(leads);
    onSave();
    setForm({ clientName: "", clientLastName: "", targetRole: "", targetMarket: "", whatsappNumber: "", scheduledAt: "", closerUsername: auth.username, notes: "" });
    onClose();
  };

  return (
    <div className="demo-modal-overlay" onClick={onClose} data-testid="new-lead-modal">
      <div className="demo-modal" onClick={(e) => e.stopPropagation()}>
        <div className="demo-modal-header">
          <h2>New lead</h2>
          <button onClick={onClose} className="demo-modal-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="demo-modal-body">
          <div className="demo-field">
            <Label>First name *</Label>
            <Input value={form.clientName} onChange={(e) => update("clientName", e.target.value)} placeholder="e.g. Sarah" data-testid="new-lead-name" />
          </div>
          <div className="demo-field">
            <Label>Last name</Label>
            <Input value={form.clientLastName} onChange={(e) => update("clientLastName", e.target.value)} placeholder="e.g. K." />
          </div>
          <div className="demo-field-row">
            <div className="demo-field">
              <Label>Target role *</Label>
              <Input value={form.targetRole} onChange={(e) => update("targetRole", e.target.value)} placeholder="e.g. Product Manager" data-testid="new-lead-role" />
            </div>
            <div className="demo-field">
              <Label>Target market *</Label>
              <Input value={form.targetMarket} onChange={(e) => update("targetMarket", e.target.value)} placeholder="e.g. United States" data-testid="new-lead-market" />
            </div>
          </div>
          <div className="demo-field">
            <Label>WhatsApp number</Label>
            <Input value={form.whatsappNumber} onChange={(e) => update("whatsappNumber", e.target.value)} placeholder="+1234567890" />
          </div>
          <div className="demo-field">
            <Label>Demo date & time</Label>
            <Input type="datetime-local" value={form.scheduledAt} onChange={(e) => update("scheduledAt", e.target.value)} data-testid="new-lead-datetime" />
          </div>
          <div className="demo-field">
            <Label>Assigned closer</Label>
            <select className="demo-select" value={form.closerUsername} onChange={(e) => update("closerUsername", e.target.value)}>
              {CLOSER_ACCOUNTS.map((a) => (
                <option key={a.username} value={a.username}>{a.name} ({a.username})</option>
              ))}
            </select>
          </div>
          <div className="demo-field">
            <Label>Notes</Label>
            <Textarea value={form.notes} onChange={(e) => update("notes", e.target.value)} placeholder="Any notes about this lead..." rows={3} />
          </div>
        </div>
        <div className="demo-modal-footer">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={handleSave} disabled={!form.clientName || !form.targetRole || !form.targetMarket} data-testid="save-lead-btn" className="crm-new-lead-btn">
            Save lead
          </Button>
        </div>
      </div>
    </div>
  );
}
